import { render, staticRenderFns } from "./ModalBody.vue?vue&type=template&id=0c1e91b0&lang=pug&"
import script from "./ModalBody.vue?vue&type=script&lang=js&"
export * from "./ModalBody.vue?vue&type=script&lang=js&"
import style0 from "./ModalBody.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports